import { getDependencyTree, Reaction } from "mobx"

export function printDebugValue(v: Reaction) {
    return getDependencyTree(v)
}
